import { useLazyQuery,gql } from "@apollo/client";

const GET_CLIENT_MEDICAL_FORM_DETAILS=gql`
query GetClientMedicalFormDetails($clientId: Int!, $token: String) {
  getClientMedicalFormDetails(clientId: $clientId, token: $token) {
    success
    message
    data {
      id
      usr_id
      name
      email
      dob
      mobile
      phone_country
      country_code
      latitude
      longitude
      address
      house_no
      street_name
      city
      postcode
      title
      medical_home_phone
      medical_office_phone
      medical_qas {
        question
        id
        isManual
        hasSubQuestions
        subQuestions {
          question
          id
          isManual
          comment
          answer
        }
        comment
        answer
      }
      practitioner_signature
      medical_signature
      isPractitionerDetail
      isConfirmedByClient
      hasMedicalHistory
      businessName
      companyProfile
    }
  }
}
`;

export const GetClientMedicalFormDetailsAction=()=>{
    const [
        getClientMedicalFormDetailsResponseFunction,
        getClientMedicalFormDetailsResponseData
    ]=useLazyQuery(GET_CLIENT_MEDICAL_FORM_DETAILS,{
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
        onCompleted:({getClientMedicalFormDetails:responseData})=>{
            if(responseData.success){
                console.log("res",responseData)
            }else{
                console.log("error")
            }
        }
    })

    const getclientMedicalFormDetailsQueryData=getClientMedicalFormDetailsResponseData;

    const initGetClientMedicalFormData=(data)=>{
        getClientMedicalFormDetailsResponseFunction({
            variables:data
        })
    }

    return {getclientMedicalFormDetailsQueryData ,initGetClientMedicalFormData }
}